module.exports = __webpack_public_path__ + "static/media/8-8.da275cb1.mp3";